import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "rsi-player",
  class: "rs_addtools rs_splitbutton rs_preserve rs_skip rs_exp"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]

import { useStore } from "vuex";
import { watch, ref, computed, nextTick } from "vue";
import AppError from "@/components/AppError.vue";
import RSInjectConfig from "../config.json";


export default /*@__PURE__*/_defineComponent({
  __name: 'RSInject',
  setup(__props) {

const store = useStore();

const loaded = computed(() => store.getters["rsinject/loaded"]);
const error = computed(() => store.getters["rsinject/error"]);
const enabled = computed(() => store.getters["rsinject/enabled"]);
const errorVisible = ref(false);

watch(enabled, (value) => {
  if (value) {
    nextTick(() => {
      window.rspkr && window.rspkr.tools.toggler.add();
    });
  }
});
watch(error, (value) => {
  errorVisible.value = value;
});

function load() {
  store.dispatch("rsinject/load");
}
function enable() {
  store.dispatch("rsinject/enable");
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function disable() {
  store.dispatch("rsinject/disable");
}

function closeErrorModal() {
  errorVisible.value = false;
}

const dictionary = RSInjectConfig.dictionary;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loaded.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (enabled.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "rsi-enable-link",
                onClick: enable,
                title: _unref(dictionary).link_enable
              }, _toDisplayString(_unref(dictionary).link_enable), 9, _hoisted_2))
        ], 64))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "rsi-load-link",
          onClick: load,
          title: _unref(dictionary).link_load
        }, _toDisplayString(_unref(dictionary).link_load), 9, _hoisted_3)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (errorVisible.value)
          ? (_openBlock(), _createBlock(AppError, {
              key: 0,
              onClose: closeErrorModal,
              title: _unref(dictionary).error_title,
              text: _unref(dictionary).error_text,
              buttonLabel: _unref(dictionary).error_close
            }, null, 8, ["title", "text", "buttonLabel"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})